import React from "react";
import { Table, Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./sidebar.css";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activate1: false,
      activate2: false,
      activate3: false,
      activate4: false,
      activate5: false,
      activate6: false,
      activate7: false,
    };
  }

  componentDidMount = (props) => {
    const lg1 = document.getElementById("lg1");
    const lg2 = document.getElementById("lg2");
    const lg3 = document.getElementById("lg3");
    const lg4 = document.getElementById("lg4");
    const lg5 = document.getElementById("lg5");
    if (lg1 && lg2 && lg3 && lg4 && lg5) {
      switch (this.props.activate) {
        case "1":
          this.setState({ activate1: true });
          break;
        case "2":
          lg1.style.backgroundColor = "#05ca83";
          lg1.style.color = "#fff";
          lg1.style.border = "none";
          lg2.style.backgroundColor = "#fff";
          lg2.style.color = "#495057";
          lg2.style.border = "none";
          lg3.style.backgroundColor = "#fff";
          lg3.style.color = "#495057";
          lg3.style.border = "none";
          lg4.style.backgroundColor = "#fff";
          lg4.style.color = "#495057";
          lg4.style.border = "none";
          lg5.style.backgroundColor = "#fff";
          lg5.style.color = "#495057";
          lg5.style.border = "none";
          this.setState({ activate2: true });
          break;
        case "3":
          this.setState({ activate3: true });
          lg1.style.backgroundColor = "#fff";
          lg1.style.color = "#495057";
          lg1.style.border = "none";
          lg2.style.backgroundColor = "#05ca83";
          lg2.style.color = "#fff";
          lg2.style.border = "none";
          lg3.style.backgroundColor = "#fff";
          lg3.style.color = "#495057";
          lg3.style.border = "none";
          lg4.style.backgroundColor = "#fff";
          lg4.style.color = "#495057";
          lg4.style.border = "none";
          lg5.style.backgroundColor = "#fff";
          lg5.style.color = "#495057";
          lg5.style.border = "none";
          break;
        case "4":
          this.setState({ activate4: true });
          lg1.style.backgroundColor = "#fff";
          lg1.style.color = "#495057";
          lg1.style.border = "none";
          lg2.style.backgroundColor = "#fff";
          lg2.style.color = "#495057";
          lg2.style.border = "none";
          lg3.style.backgroundColor = "#05ca83";
          lg3.style.color = "#fff";
          lg3.style.border = "none";
          lg4.style.backgroundColor = "#fff";
          lg4.style.color = "#495057";
          lg4.style.border = "none";
          lg5.style.backgroundColor = "#fff";
          lg5.style.color = "#495057";
          lg5.style.border = "none";
          break;
        case "5":
          this.setState({ activate5: true });
          lg1.style.backgroundColor = "#fff";
          lg1.style.color = "#495057";
          lg1.style.border = "none";
          lg2.style.backgroundColor = "#fff";
          lg2.style.color = "#495057";
          lg2.style.border = "none";
          lg3.style.backgroundColor = "#fff";
          lg3.style.color = "#495057";
          lg3.style.border = "none";
          lg4.style.backgroundColor = "#05ca83";
          lg4.style.color = "#fff";
          lg4.style.border = "none";
          lg5.style.backgroundColor = "#fff";
          lg5.style.color = "#495057";
          lg5.style.border = "none";
          break;
        case "6":
          this.setState({ activate6: true });
          lg1.style.backgroundColor = "#fff";
          lg1.style.color = "#495057";
          lg1.style.border = "none";
          lg2.style.backgroundColor = "#fff";
          lg2.style.color = "#495057";
          lg2.style.border = "none";
          lg3.style.backgroundColor = "#fff";
          lg3.style.color = "#495057";
          lg3.style.border = "none";
          lg4.style.backgroundColor = "#fff";
          lg4.style.color = "#495057";
          lg4.style.border = "none";
          lg5.style.backgroundColor = "#05ca83";
          lg5.style.color = "#fff";
          lg5.style.border = "none";
          break;
        case "7":
          this.setState({ activate6: true });
          break;
      }
    }
  };

  render() {
    return (
      <Tab.Container defaultActiveKey="add">
        <Row>
          <div className="sidebar-container1">
            <div className="sidebar-container2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    id="lg1"
                    action
                    active={this.state.activate2}
                    href="#/relatorios/ordens"
                  >
                    Histórico de Ordens
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg2"
                    action
                    active={this.state.activate3}
                    href="#/relatorios/paradas"
                  >
                    Histórico de Paradas
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg3"
                    action
                    active={this.state.activate4}
                    href="#/relatorios/refugos"
                  >
                    Histórico de Refugos
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg4"
                    action
                    active={this.state.activate5}
                    href="#/relatorios/oee"
                  >
                    Apontamentos
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg5"
                    action
                    active={this.state.activate6}
                    href="#/relatorios/andon"
                  >
                    Andon
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>

            <Col>
              <Tab.Content></Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}
export default Sidebar;